enum InterventionActionFieldNames {
  Assignee = 'assignee',
  AssigneeList = 'assigneeList',
  AttachmentsAttached = 'attachmentsAttached',
  Category = 'category',
  Description = 'description',
  DurationTime = 'durationTime',
  EstimatedDate = 'estimatedDate',
  EstimatedTime = 'estimatedTime',
  Id = 'id',
  LogisticTime = 'logisticTime',
  Site = 'site',
  Status = 'status',
  DetailsTitle = 'details-title',
  AssignAction = 'assign-action',
  TimingTitle = 'timing-title',
}

export default InterventionActionFieldNames;
